import constants from '../settings/constants';

function isFixedRoom() {
  return !!constants.WALL;
}

export { isFixedRoom };
